import {
    TableCellProps,
    useTheme,
    useMediaQuery,
    TableCell
} from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

import React from "react";

export interface IResponsiveTableCell extends TableCellProps {
    hiddenWhen?: Breakpoint | number;
}

const ResponsiveTableCell: React.FC<IResponsiveTableCell> = props => {
    const { hiddenWhen, ...rest } = props;

    const theme = useTheme();

    const breakpoint = hiddenWhen;

    const showCell = !useMediaQuery(theme.breakpoints.down(breakpoint ?? "xl"));

    if (!hiddenWhen || showCell) {
        return <TableCell {...(rest as TableCellProps)} />;
    }

    return <></>;
};

export default ResponsiveTableCell;
